import { addDays, format, getDaysInMonth, startOfMonth } from 'date-fns';
import dayjs from 'dayjs';

export interface DayOption {
  ma: string;
  ten: string;
}

export const generateDaysInCurrentMonth = (): DayOption[] => {
  const today = new Date();
  const daysInMonth = getDaysInMonth(today);
  const firstDayOfMonth = startOfMonth(today);

  const days = [];
  for (let i = 0; i < daysInMonth; i++) {
    const date = addDays(firstDayOfMonth, i);
    const day = format(date, 'd');
    const formattedDay = day.padStart(2, '0');
    days.push({
      ma: formattedDay,
      ten: `Ngày ${parseInt(day, 10)}`
    });
  }

  return days;
};

export interface DateRangeOption {
  id: string;
  label: string;
  getValue: (today: dayjs.Dayjs) => { from: string; to: string };
}

export const DATE_RANGE_OPTIONS: DateRangeOption[] = [
  // Following the exact order from dateOptions array
  {
    id: 'thisMonth',
    label: 'Tháng này',
    getValue: today => ({
      from: today.startOf('month').format('YYYY-MM-DD'),
      to: today.endOf('month').format('YYYY-MM-DD')
    })
  },
  {
    id: 'startOfMonthToNow',
    label: 'Đầu tháng đến hiện tại',
    getValue: today => ({
      from: today.startOf('month').format('YYYY-MM-DD'),
      to: today.format('YYYY-MM-DD')
    })
  },
  {
    id: 'lastMonth',
    label: 'Tháng trước',
    getValue: today => {
      const lastMonth = today.subtract(1, 'month');
      return {
        from: lastMonth.startOf('month').format('YYYY-MM-DD'),
        to: lastMonth.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'nextMonth',
    label: 'Tháng sau',
    getValue: today => {
      const nextMonth = today.add(1, 'month');
      return {
        from: nextMonth.startOf('month').format('YYYY-MM-DD'),
        to: nextMonth.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'today',
    label: 'Hôm nay',
    getValue: today => ({
      from: today.format('YYYY-MM-DD'),
      to: today.format('YYYY-MM-DD')
    })
  },
  {
    id: 'thisWeek',
    label: 'Tuần này',
    getValue: today => ({
      from: today.startOf('week').format('YYYY-MM-DD'),
      to: today.endOf('week').format('YYYY-MM-DD')
    })
  },
  {
    id: 'month1',
    label: 'Tháng 1',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-01-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month2',
    label: 'Tháng 2',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-02-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month3',
    label: 'Tháng 3',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-03-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month4',
    label: 'Tháng 4',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-04-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month5',
    label: 'Tháng 5',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-05-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month6',
    label: 'Tháng 6',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-06-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month7',
    label: 'Tháng 7',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-07-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month8',
    label: 'Tháng 8',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-08-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month9',
    label: 'Tháng 9',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-09-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month10',
    label: 'Tháng 10',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-10-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month11',
    label: 'Tháng 11',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-11-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'month12',
    label: 'Tháng 12',
    getValue: today => {
      const year = today.year();
      const month = dayjs(`${year}-12-01`);
      return {
        from: month.startOf('month').format('YYYY-MM-DD'),
        to: month.endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'quarter1',
    label: 'Quý 1',
    getValue: today => {
      const year = today.year();
      const quarter = dayjs(`${year}-01-01`);
      return {
        from: quarter.format('YYYY-MM-DD'),
        to: dayjs(`${year}-03-31`).format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'quarter2',
    label: 'Quý 2',
    getValue: today => {
      const year = today.year();
      const quarter = dayjs(`${year}-04-01`);
      return {
        from: quarter.format('YYYY-MM-DD'),
        to: dayjs(`${year}-06-30`).format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'quarter3',
    label: 'Quý 3',
    getValue: today => {
      const year = today.year();
      const quarter = dayjs(`${year}-07-01`);
      return {
        from: quarter.format('YYYY-MM-DD'),
        to: dayjs(`${year}-09-30`).format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'quarter4',
    label: 'Quý 4',
    getValue: today => {
      const year = today.year();
      const quarter = dayjs(`${year}-10-01`);
      return {
        from: quarter.format('YYYY-MM-DD'),
        to: dayjs(`${year}-12-31`).format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'thisQuarter',
    label: 'Quý này',
    getValue: today => {
      // Calculate current quarter (months 0-2 = Q1, 3-5 = Q2, 6-8 = Q3, 9-11 = Q4)
      const month = today.month();
      const quarterStartMonth = Math.floor(month / 3) * 3;
      const quarterEndMonth = quarterStartMonth + 2;
      const year = today.year();

      return {
        from: today.month(quarterStartMonth).startOf('month').format('YYYY-MM-DD'),
        to: today.month(quarterEndMonth).endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'lastQuarter',
    label: 'Quý trước',
    getValue: today => {
      // Calculate last quarter
      const month = today.month();
      const currentQuarter = Math.floor(month / 3);
      const lastQuarter = currentQuarter - 1;

      // Handle previous year if current quarter is Q1
      const year = today.year();
      const targetYear = lastQuarter < 0 ? year - 1 : year;
      const targetQuarter = lastQuarter < 0 ? 3 : lastQuarter; // If negative, it's Q4 of previous year

      const quarterStartMonth = targetQuarter * 3;
      const quarterEndMonth = quarterStartMonth + 2;

      return {
        from: dayjs().year(targetYear).month(quarterStartMonth).startOf('month').format('YYYY-MM-DD'),
        to: dayjs().year(targetYear).month(quarterEndMonth).endOf('month').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'startOfQuarterToNow',
    label: 'Đầu quý đến hiện tại',
    getValue: today => {
      // Calculate current quarter start month
      const month = today.month();
      const quarterStartMonth = Math.floor(month / 3) * 3;

      return {
        from: today.month(quarterStartMonth).startOf('month').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'thisYear',
    label: 'Năm nay',
    getValue: today => ({
      from: today.startOf('year').format('YYYY-MM-DD'),
      to: today.endOf('year').format('YYYY-MM-DD')
    })
  },
  {
    id: 'lastYear',
    label: 'Năm trước',
    getValue: today => {
      const lastYear = today.subtract(1, 'year');
      return {
        from: lastYear.startOf('year').format('YYYY-MM-DD'),
        to: lastYear.endOf('year').format('YYYY-MM-DD')
      };
    }
  },
  {
    id: 'startOfYearToNow',
    label: 'Đầu năm đến hiện tại',
    getValue: today => ({
      from: today.startOf('year').format('YYYY-MM-DD'),
      to: today.format('YYYY-MM-DD')
    })
  }
];

// Utility function for date formatting (following codebase pattern)
export function formatDateToDDMMYYYY(date: Date | string | null | undefined): string {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) return '';

    return format(dateObj, 'dd/MM/yyyy');
  } catch (error) {
    // Fallback to manual formatting
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
